import { createSlice } from "@reduxjs/toolkit";

const name = "c_tour";

const RoomsType = {
  index: 0,
  room_category_id: 0,
  room_price: 0,
  extrabed: false,
  extrabed_price: 0,
};

const tourD = {
  index: 0,
  date: " ",
  city_id: 0,
  tour_id: 0,
  accommodation: false,
  tourguide: 0,
  tourguide_price: 0,
  accommodation_id: null,
  accommodation_price: 0,
  number_of_rooms: 0,
  roomsCategories: [],
};

// custom function to icrease date
const incrementDate = (dateToInc, index) => {
  const initialDate = new Date(dateToInc);
  initialDate.setDate(initialDate.getDate() + index);
  return initialDate.toISOString().split("T")[0];
};

const initialState = {
  tour_data: {
    cooperator_id: null,
    // destination_id: null,
    tour_name: null,
    package_id: null,
    tour_title_id: null,
    transportation_id: null,
    transportation_Type_price: 0,
    from: "",
    till: "",
    number_of_days: 0,
    number_of_people: 2,
    website: false,
    my_offer: false,
    tourDetails: [],
    tourguide_price: 0,
    transportation_price: 0,
    hotels_price: 0,
    profit_price: 0,
    total_price: 0,
    reserved: null,
    logo: "",
  },
  package_titles: [],
};

const reducers = {
  set_cooperator_id: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, cooperator_id: payload },
    };
  },
  set_my_offer: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, my_offer: payload },
    };
  },
  set_website: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, website: payload },
    };
  },
  set_tour_logo: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, logo: payload },
    };
  },
  set_destination_id: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, destination_id: payload },
    };
  },
  handleChange_tour_name: (state, { payload }) => {
    return { ...state, tour_data: { ...state.tour_data, tour_name: payload } };
  },
  handleChange_number_of_people: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, number_of_people: payload },
    };
  },
  handleChange_tour_title: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, tour_title_id: payload },
    };
  },
  Get_package_titles: (state, { payload }) => {
    return { ...state, package_titles: payload };
  },
  handleChange_transportation_id: (state, { payload: { id, price } }) => {
    return {
      ...state,
      tour_data: {
        ...state.tour_data,
        transportation_id: id,
        transportation_Type_price: price,
      },
    };
  },
  handleChange_from_date: (state, { payload: { from, till } }) => {
    // Update from and till dates in the tour data
    const updatedData = {
      ...state.tour_data,
      from,
      till,
    };

    // Convert the from date to a Date object
    const fromDate = new Date(from);

    // Update dates in tourDetails
    const updatedTourDetails = state.tour_data.tourDetails.map(
      (detail, index) => {
        // Add the index number of days to the from date
        const detailDate = new Date(fromDate);
        detailDate.setDate(fromDate.getDate() + index);

        return {
          ...detail,
          date: detailDate.toISOString().split("T")[0],
        };
      }
    );

    return {
      ...state,
      tour_data: {
        ...updatedData,
        tourDetails: updatedTourDetails,
      },
    };
  },
  handleChange_inc: (state) => {
    const newNumberOfDays = state.tour_data.number_of_days + 1;
    const tillDate = new Date(state.tour_data.till);
    tillDate.setDate(tillDate.getDate() + 1);
    const till = tillDate.toISOString().split("T")[0] || null;

    if (newNumberOfDays <= 30) {
      const package_title = state.package_titles.find(
        (item) => item.package_title?.no_days === newNumberOfDays
      );

      const existingTourDetails = state.tour_data.tourDetails; // Copy existing tour details
      const lastTourDetailIndex = existingTourDetails.length - 1; // Index of the last tour detail

      // If the last tour detail exists, start incrementing the index from its next index
      const startIndex = lastTourDetailIndex >= 0 ? lastTourDetailIndex + 1 : 0;
      // console.log("startIndex", startIndex);

      const newTourDetails = Array.from(
        { length: newNumberOfDays - existingTourDetails.length }, // Calculate the length of new tour details to be added
        (_, index) => ({
          ...tourD,
          index: startIndex + index + 1, // Increment index by startIndex + 1 to avoid repetition
          date: incrementDate(state.tour_data.from, startIndex + index),
        })
      );

      return {
        ...state,
        tour_data: {
          ...state.tour_data,
          number_of_days: newNumberOfDays,
          till,
          package_id: package_title ? package_title.id : 0,
          package_title_name: package_title
            ? package_title.package_title.title_en
            : "",
          tourDetails: [...existingTourDetails, ...newTourDetails], // Concatenate existing and new tour details
          //   tourguide_price: [...state.data.tourguide_price, { price: 0 }],
        },
      };
    }
    return state; // Return state unchanged if the number of days exceeds 30
  },
  handleChange_dec: (state) => {
    const newNumberOfDays = state.tour_data.number_of_days - 1;

    if (newNumberOfDays >= 1) {
      const package_title = state.package_titles.find(
        (item) => item.package_title?.no_days === newNumberOfDays
      );
      const slicedTourDetails = state.tour_data.tourDetails.slice(0, -1);

      return {
        ...state,
        tour_data: {
          ...state.tour_data,
          number_of_days: newNumberOfDays,
          till: incrementDate(state.tour_data.till, -1), // Subtracting 1 day from till date
          package_id: package_title ? package_title.id : 0,
          package_title_name: package_title
            ? package_title.package_title.title_en
            : "",
          tourDetails: slicedTourDetails,
        },
      };
    }

    return state; // Return state unchanged if the number of days is already 1
  },
  handleChange_City: (state, { payload: { index, id } }) => {
    // console.log(index, id);
    if (state.tour_data.tourDetails[index]) {
      const updatedTourDetails = [...state.tour_data.tourDetails];
      updatedTourDetails[index] = { ...updatedTourDetails[index], city_id: id };
      return {
        ...state,
        tour_data: { ...state.tour_data, tourDetails: updatedTourDetails },
      };
    }
    return state; // Return state unchanged if the index is out of bounds
  },
  handleChange_roomCategory: (
    state,
    {
      payload: {
        tourDetailIndex,
        roomCategoryIndex,
        roomCategoryId,
        roomPrice,
      },
    }
  ) => {
    // Check if the tourDetailIndex is within bounds
    if (state.tour_data.tourDetails[tourDetailIndex]) {
      // Check if the roomCategoryIndex is within bounds
      if (
        state.tour_data.tourDetails[tourDetailIndex].roomsCategories[
          roomCategoryIndex
        ]
      ) {
        // Update room_category_id and room_price in the specified roomsCategories array
        state.tour_data.tourDetails[tourDetailIndex].roomsCategories[
          roomCategoryIndex
        ].room_category_id = roomCategoryId;
        state.tour_data.tourDetails[tourDetailIndex].roomsCategories[
          roomCategoryIndex
        ].room_price = roomPrice;
      }
    }

    return state;
  },
  handleChange_extrabed_checkbox: (
    state,
    {
      payload: { tourDetailIndex, roomCategoryIndex, extrabed, extrabed_price },
    }
  ) => {
    // Check if the tourDetailIndex is within bounds
    if (state.tour_data.tourDetails[tourDetailIndex]) {
      // Check if the roomCategoryIndex is within bounds
      if (
        state.tour_data.tourDetails[tourDetailIndex].roomsCategories[
          roomCategoryIndex
        ]
      ) {
        // Update room_category_id and room_price in the specified roomsCategories array
        state.tour_data.tourDetails[tourDetailIndex].roomsCategories[
          roomCategoryIndex
        ].extrabed = extrabed;
        state.tour_data.tourDetails[tourDetailIndex].roomsCategories[
          roomCategoryIndex
        ].extrabed_price = extrabed_price;
      }
    }

    return state;
  },
  handleChange_day_tourTitle: (state, { payload: { index, id } }) => {
    if (state.tour_data.tourDetails[index]) {
      const updatedTourDetails = [...state.tour_data.tourDetails];
      updatedTourDetails[index] = { ...updatedTourDetails[index], tour_id: id };
      return {
        ...state,
        tour_data: { ...state.tour_data, tourDetails: updatedTourDetails },
      };
    }
    return state; // Return state unchanged if the index is out of bounds
  },
  handleChange_accommodation_check: (state, { payload: { index, status } }) => {
    if (state.tour_data.tourDetails[index]) {
      const updatedTourDetails = [...state.tour_data.tourDetails];

      updatedTourDetails[index] = {
        ...updatedTourDetails[index],
        accommodation: status,
        accommodation_id: null,
        accommodation_price: 0,
        roomsCategories: [],
      };
      return {
        ...state,
        tour_data: { ...state.tour_data, tourDetails: updatedTourDetails },
      };
    }
    return state; // Return state unchanged if the index is out of bounds
  },
  handleChange_accomodation: (state, { payload: { index, id } }) => {
    if (state.tour_data.tourDetails[index]) {
      const updatedTourDetails = [...state.tour_data.tourDetails];
      updatedTourDetails[index] = {
        ...updatedTourDetails[index],
        accommodation_id: id,
      };
      return {
        ...state,
        tour_data: { ...state.tour_data, tourDetails: updatedTourDetails },
      };
    }
    return state; // Return state unchanged if the index is out of bounds
  },
  handleChange_tourguide_checked: (
    state,
    { payload: { index, check, price } }
  ) => {
    if (state.tour_data.tourDetails[index]) {
      const updatedTourDetails = [...state.tour_data.tourDetails];
      updatedTourDetails[index] = {
        ...updatedTourDetails[index],
        tourguide: check,
        tourguide_price: price,
      };
      return {
        ...state,
        tour_data: { ...state.tour_data, tourDetails: updatedTourDetails },
      };
    }
    return state; // Return state unchanged if the index is out of bounds
  },

  handleChange_number_of_rooms: (state, { payload: { index, number } }) => {
    // Update number_of_rooms in tourDetails at the specified index
    if (number > 0 && number < 11) {
      if (state.tour_data.tourDetails[index]) {
        state.tour_data.tourDetails[index].number_of_rooms = parseFloat(number);
        // Generate RoomsType array with length equal to number
        const roomsCategories = Array.from(
          { length: number },
          (_, roomIndex) => ({
            ...RoomsType,
            index: roomIndex + 1,
          })
        );
        // Update roomsCategories in tourDetails at the specified index
        state.tour_data.tourDetails[index].roomsCategories = roomsCategories;
      }
    }
    return state;
  },
  handleChange_profit_price: (state, { payload }) => {
    return {
      ...state,
      tour_data: { ...state.tour_data, profit_price: parseFloat(payload) },
    };
  },
  calculateHotelPrice: (state, { payload: { tourDetailIndex } }) => {
    // Get the current tour details
    const { tourDetails } = state.tour_data;

    // Check if the specified tourDetailIndex is within bounds
    if (tourDetails[tourDetailIndex]) {
      // Get the tour detail at the specified index
      const tourDetail = tourDetails[tourDetailIndex];

      // Calculate total room price for the specified tour detail
      const totalRoomPrice = tourDetail.roomsCategories.reduce(
        (roomTotal, roomCategory) => {
          // Add room price
          let roomPrice = roomCategory.room_price;
          // Add extrabed price if extrabed is selected
          if (roomCategory.extrabed) {
            roomPrice += roomCategory.extrabed_price;
          }
          return roomTotal + roomPrice;
        },
        0
      );

      // Update the specified tour detail's accommodation price with the calculated total room price
      const updatedTourDetails = [...tourDetails];
      updatedTourDetails[tourDetailIndex] = {
        ...tourDetail,
        accommodation_price: totalRoomPrice,
      };

      // Update state with the updated tour details
      return {
        ...state,
        tour_data: {
          ...state.tour_data,
          tourDetails: updatedTourDetails,
        },
      };
    }

    return state; // Return state unchanged if the index is out of bounds
  },
  calculateTransportationPrice: (state) => {
    // Calculate total transportation price
    const transportationPrice =
      state.tour_data.transportation_Type_price *
      state.tour_data.number_of_days;

    // Update state with the calculated total transportation price
    return {
      ...state,
      tour_data: {
        ...state.tour_data,
        transportation_price: transportationPrice,
      },
    };
  },
  calculateAccommodationsPrice: (state) => {
    // Calculate total hotels price by summing up accommodation prices in tourDetails
    const totalHotelsPrice = state.tour_data.tourDetails.reduce(
      (total, detail) => {
        return total + detail.accommodation_price;
      },
      0
    );

    // Update state with the calculated total hotels price
    return {
      ...state,
      tour_data: {
        ...state.tour_data,
        hotels_price: totalHotelsPrice,
      },
    };
  },
  calculateTourguidePrice: (state) => {
    // Calculate total tourguide price by summing up tourguide prices in tourDetails
    const totalTourguidePrice = state.tour_data.tourDetails.reduce(
      (total, detail) => {
        return total + detail.tourguide_price;
      },
      0
    );

    // Update state with the calculated total tourguide price
    return {
      ...state,
      tour_data: {
        ...state.tour_data,
        tourguide_price: totalTourguidePrice,
      },
    };
  },
  calculateTotalPrice: (state) => {
    // Calculate total price
    const totalPrice =
      state.tour_data.tourguide_price +
      state.tour_data.transportation_price +
      state.tour_data.hotels_price +
      state.tour_data.profit_price;

    // Update state with the calculated total price
    return {
      ...state,
      tour_data: {
        ...state.tour_data,
        total_price: totalPrice,
      },
    };
  },
  resetTourData: (state) => {
    return {
      ...state,
      tour_data: {
        ...initialState.tour_data, // Reset to initial structure
        tourDetails: [], // Reset tour details to an empty array
      },
    };
  },

  resetState: (state) => initialState,
};

const TourSlice = createSlice({
  name,
  initialState,
  reducers,
});

export const {
  set_cooperator_id,
  set_destination_id,
  set_tour_logo,

  handleChange_tour_name,
  handleChange_number_of_people,
  handleChange_transportation_id,
  handleChange_tour_title,
  handleChange_from_date,
  Get_package_titles,
  //
  handleChange_inc,
  handleChange_dec,
  handleChange_City,
  handleChange_day_tourTitle,
  handleChange_accommodation_check,
  handleChange_tourguide_checked,
  handleChange_accomodation,
  handleChange_number_of_rooms,
  handleChange_roomCategory,
  handleChange_extrabed_checkbox,
  handleChange_apartment,
  handleChange_profit_price,
  calculateTransportationPrice,
  calculateTourguidePrice,
  calculateAccommodationsPrice,
  calculateTotalPrice,
  calculateHotelPrice,
  resetState,
  set_my_offer,
  set_website,
  resetTourData,
} = TourSlice.actions;
export default TourSlice.reducer;
